import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Network, Users, Zap, Brain, Globe, Package } from 'lucide-react';
import { LandingAIFeatures } from './LandingAIFeatures';
export const LandingLCN = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: Users,
      title: "Unified Collaboration",
      description: "Customers and carriers work together seamlessly"
    },
    {
      icon: Brain,
      title: "AI-Powered Operations",
      description: "Smart order assignment and intelligent tracking"
    },
    {
      icon: Zap,
      title: "Real-Time Visibility",
      description: "Live updates and instant document sharing"
    },
    {
      icon: Network,
      title: "No Middlemen",
      description: "Direct connection eliminates communication gaps"
    }
  ];

  const howItWorks = [
    {
      step: "01",
      title: "Customers Invite Carriers",
      description: "Build your trusted network by inviting carriers to your workspace"
    },
    {
      step: "02", 
      title: "Carriers Manage Orders",
      description: "Handle multiple customers from one unified dashboard"
    },
    {
      step: "03",
      title: "Real-Time Sync",
      description: "Everything stays connected: shipments, communication, tracking"
    }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-br from-primary/5 via-background to-primary/5">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center animate-fade-in">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Network className="h-10 w-10 text-primary" />
            <Badge variant="secondary" className="px-3 py-1">
              {t('landing.lcn.badge')}
            </Badge>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
            {t('landing.lcn.title')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto mb-6">
            {t('landing.lcn.description')}
          </p>
          <div className="mt-12 md:mt-16">
            <LandingAIFeatures embedded />
          </div>
          
        </div>
      </div>
    </section>
  );
};